export function notZl (file,gh_cl,notGh_cl,byzl_no) {
  // file: 判断有没有数据 , gh_cl：必要材料字段 ， notGh_cl 传过来的字符 ， 拼接数据byzl_no  （查出是否gh_cl是否包含notGh_cl传过来的字符）
  byzl_no=byzl_no ? byzl_no :''
    let zl;
  if (file <= 0 && gh_cl!=null) {
    if (!(gh_cl.indexOf(notGh_cl) === -1)) {
       zl = byzl_no ? byzl_no + ',' + notGh_cl : notGh_cl
    } else {
      zl = byzl_no.replace(notGh_cl, '')
    }
  } else {
    zl =byzl_no.replace(notGh_cl, '')
  }
  return zl;
}



// WEBPACK FOOTER //
// ./src/utils/NotZl.js